import React from 'react';

import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import { IAuthCampaign } from 'pages/authentication/components/auth-campaigns/hooks/use-auth-campaign';

import { SignInForm } from './sign-in-form';

interface ISignInFormProps {
  authCampaignExtraFields?: IAuthCampaign['extraFields'];
}

export const SignIn = ({ authCampaignExtraFields }: ISignInFormProps) => {
  useRumPageView('sign-in', 'Sign In');

  return <SignInForm authCampaignExtraFields={authCampaignExtraFields} />;
};
